"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryGuestAdventureService = void 0;
exports.normalizeGuestAdventureVariables = normalizeGuestAdventureVariables;
exports.normalizeGuestAdventureCreateOptions = normalizeGuestAdventureCreateOptions;
/**
 * Coerce effect-script variables object to string map for invitePayload storage.
 */
function normalizeGuestAdventureVariables(variablesObject) {
    if (!variablesObject || typeof variablesObject !== 'object' || Array.isArray(variablesObject)) {
        throw new Error('createGuestAdventure requires a plain variables object');
    }
    const result = {};
    for (const [key, value] of Object.entries(variablesObject)) {
        const name = key.trim();
        if (!name) {
            continue;
        }
        if (value === undefined || value === null) {
            continue;
        }
        result[name] = String(value);
    }
    return result;
}
/**
 * Validate optional createGuestAdventure options from effect scripts.
 */
function normalizeGuestAdventureCreateOptions(options) {
    if (options === undefined || options === null) {
        return undefined;
    }
    if (typeof options !== 'object' || Array.isArray(options)) {
        throw new Error('createGuestAdventure options must be a plain object');
    }
    const raw = options;
    const result = {};
    if (raw.ttlHours !== undefined && raw.ttlHours !== null) {
        const hours = Number(raw.ttlHours);
        if (!Number.isFinite(hours) || hours <= 0) {
            throw new Error('createGuestAdventure ttlHours must be a positive number');
        }
        result.ttlHours = hours;
    }
    if (raw.expiresAt !== undefined && raw.expiresAt !== null) {
        const expiresAt = String(raw.expiresAt).trim();
        if (!expiresAt) {
            throw new Error('createGuestAdventure expiresAt cannot be empty');
        }
        result.expiresAt = expiresAt;
    }
    if (raw.asCurrentUser !== undefined && raw.asCurrentUser !== null) {
        result.asCurrentUser = Boolean(raw.asCurrentUser);
    }
    return Object.keys(result).length > 0 ? result : undefined;
}
/** In-memory queue for engine tests and local harnesses. */
class InMemoryGuestAdventureService {
    constructor() {
        this.pendingByPlayer = new Map();
        this.pendingDeletesByPlayer = new Map();
        this.lastResultByPlayer = new Map();
        this.returnResultOnlyByPlayer = new Set();
        this.deleteResultOnlyByPlayer = new Set();
    }
    queueGuestAdventureCreate(adventureId, variables, options, context) {
        const list = this.pendingByPlayer.get(context.playerId) ?? [];
        list.push({ adventureId, variables, options, context });
        this.pendingByPlayer.set(context.playerId, list);
    }
    getPendingCreates(playerId) {
        return [...(this.pendingByPlayer.get(playerId) ?? [])];
    }
    getLastCreateResult(playerId) {
        return this.lastResultByPlayer.get(playerId) ?? null;
    }
    setLastCreateResult(playerId, result) {
        this.lastResultByPlayer.set(playerId, result);
    }
    clearPendingCreates(playerId) {
        this.pendingByPlayer.delete(playerId);
    }
    queueGuestAdventureDelete(inviteId, context) {
        const list = this.pendingDeletesByPlayer.get(context.playerId) ?? [];
        list.push({ inviteId, context });
        this.pendingDeletesByPlayer.set(context.playerId, list);
    }
    getPendingDeletes(playerId) {
        return [...(this.pendingDeletesByPlayer.get(playerId) ?? [])];
    }
    clearPendingDeletes(playerId) {
        this.pendingDeletesByPlayer.delete(playerId);
    }
    setReturnResultOnly(playerId, enabled) {
        if (enabled) {
            this.returnResultOnlyByPlayer.add(playerId);
        }
        else {
            this.returnResultOnlyByPlayer.delete(playerId);
        }
    }
    isReturnResultOnly(playerId) {
        return this.returnResultOnlyByPlayer.has(playerId);
    }
    setDeleteResultOnly(playerId, enabled) {
        if (enabled) {
            this.deleteResultOnlyByPlayer.add(playerId);
        }
        else {
            this.deleteResultOnlyByPlayer.delete(playerId);
        }
    }
    isDeleteResultOnly(playerId) {
        return this.deleteResultOnlyByPlayer.has(playerId);
    }
}
exports.InMemoryGuestAdventureService = InMemoryGuestAdventureService;
//# sourceMappingURL=GuestAdventureService.js.map